
<nav class="unav">
  <a class="nav-logo" href="pc_home.html">
    <img src="assets/img/logo.png" alt="Police Officers Connect Logo">
    <div><div class="nav-brand-name">Police Officers Connect</div><div class="nav-brand-sub">UMYO Network</div></div>
  </a>
  <button class="unav-tog" id="navTog" (click)="toggleNav()"><span></span><span></span><span></span></button>
  <ul class="unav-links" id="navLinks" [class.nav-open]="isNavOpen">
    <li><a routerLink="/" >Home</a></li>
    <li><a routerLink="/about" class="active">About</a></li>
    <li><a routerLink="/support">Officer Support</a></li>
    <li><a routerLink="/business">For Business</a></li>
    <li><a routerLink="/services">Type Of Services</a></li>
    <li><a routerLink="/cf">Card Features</a></li>
  </ul>
  <a href="#header" class="nav-cta">Join Now</a>
</nav>
<div class="page-hero">
  <div class="hero-grid"></div>
  <div style="position:relative;z-index:1;max-width:800px;margin:0 auto;">
    <div class="hero-badge">&#9733; Platform Overview &#9733;</div>
    <h1 class="hero-title">About <em>UMYO Police Connect</em></h1>
    <span class="gold-bar"></span>
    <p class="hero-sub">A groundbreaking networking solution designed exclusively for law enforcement professionals &mdash; uniting officers, veterans, recruiters, institutions, and supporting businesses.</p>
  </div>
</div>
<div class="page-body">
  <section class="section dark">
    <div class="container">
      <div class="sec-head" data-aos="fade-up"><span class="sec-badge">The Platform</span><h2 class="sec-title">A Platform Built <em>for Police Officers</em></h2></div>
      <div style="max-width:860px;margin:0 auto;font-family:'Source Serif 4',serif;font-size:19px;line-height:1.95;color:var(--silver);text-align:center;" data-aos="fade-up" data-aos-delay="100">
        <p>UMYO Police Connect empowers officers to connect with colleagues, family, and peers, showcase skills and achievements, access a safe exclusive environment, and participate in virtual interactive events, contests, and learning opportunities.</p>
      </div>

      <div class="grid-2" style="max-width:1000px;margin:50px auto 0;">
        <div class="card" data-aos="fade-right" data-aos-delay="0">
          <span class="card-icon">👤</span>
          <h3 class="card-title">Officers Can Upload</h3>
          <ul class="card-list">
            <li>Performance data and training records</li>
            <li>Interviews and podcasts</li>
            <li>Images and career highlights</li>
            <li>Law enforcement experience and educational achievements</li>
          </ul>
        </div>
        <div class="card" data-aos="fade-left" data-aos-delay="100">
          <span class="card-icon">🏆</span>
          <h3 class="card-title">Key Features</h3>
          <ul class="card-list">
            <li>Exclusive Social Network with verified officers only</li>
            <li>Career Visibility: Showcase service record &amp; awards</li>
            <li>Learning &amp; Development via free LMS courses</li>
            <li>Community Support &amp; family assistance programs</li>
            <li>Business Integration with officer-focused initiatives</li>
            <li>Media &amp; Recognition: Podcasts, contests, interviews</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="section navy">
    <div class="container">
      <div class="sec-head" data-aos="fade-up"><span class="sec-badge">Community &amp; Career</span><h2 class="sec-title">Community &amp; <em>Career Growth</em></h2><p class="sec-sub">UMYO Police Connect empowers the law enforcement community to thrive by providing tools to grow personally, professionally, and within the broader community.</p></div>
      <div class="grid-3">
        <div class="card" data-aos="flip-left" data-aos-delay="0"><div class="card-num">01</div><span class="card-icon">👥</span><h3 class="card-title">Networking</h3><p class="card-text">Networking opportunities with peers and mentors across the nation&rsquo;s law enforcement community.</p></div>
        <div class="card" data-aos="flip-left" data-aos-delay="80"><div class="card-num">02</div><span class="card-icon">📚</span><h3 class="card-title">Training &amp; Certifications</h3><p class="card-text">Access to training, certifications, and career development resources to advance professionally.</p></div>
        <div class="card" data-aos="flip-left" data-aos-delay="160"><div class="card-num">03</div><span class="card-icon">🏆</span><h3 class="card-title">Recognition</h3><p class="card-text">Recognition through online talent contests, podcasts, and career achievement showcases.</p></div>
        <div class="card" data-aos="flip-left" data-aos-delay="0"><div class="card-num">04</div><span class="card-icon">🔒</span><h3 class="card-title">Safe Collaboration</h3><p class="card-text">Safe spaces for collaboration, sharing knowledge, and professional growth exclusively for verified officers.</p></div>
        <div class="card" data-aos="flip-left" data-aos-delay="80"><div class="card-num">05</div><span class="card-icon">💸</span><h3 class="card-title">Online LMS</h3><p class="card-text">Free online courses through our Learning Management System and private coaching and therapy access.</p></div>
        <div class="card" data-aos="flip-left" data-aos-delay="160"><div class="card-num">06</div><span class="card-icon">🌎</span><h3 class="card-title">Nationwide Reach</h3><p class="card-text">Connecting law enforcement professionals, institutions, and businesses across the entire United States.</p></div>
      </div>
    </div>
  </section>

  <section class="section dark">
    <div class="container">
      <div class="sec-head" data-aos="fade-up"><span class="sec-badge">Allocation Model</span><h2 class="sec-title">Structured <em>Fund Allocation</em></h2><p class="sec-sub">Transparent, compliance-driven distribution of every membership dollar collected.</p></div>
      <div class="alloc-wrap">
        <div class="alloc" data-aos="fade-right" data-aos-delay="0">
          <div class="alloc-top"><span class="alloc-name">30% &rarr; Officer &amp; Family Relief Fund</span><span class="alloc-pct" style="color:var(--gold);">30%</span></div>
          <div class="alloc-track"><div class="alloc-fill f30" id="bar1"></div></div>
          <div class="alloc-note">Rent / Mortgage assistance &middot; Car payment help &middot; Grocery &amp; gas cards &middot; Utility bill support &middot; Mental health &amp; stress coaching</div>
        </div>
        <div class="alloc" data-aos="fade-right" data-aos-delay="150">
          <div class="alloc-top"><span class="alloc-name">20% &rarr; Community Support Programs</span><span class="alloc-pct" style="color:var(--blue-bright);">20%</span></div>
          <div class="alloc-track"><div class="alloc-fill f20" id="bar2"></div></div>
          <div class="alloc-note">Family assistance services &middot; Youth &amp; safety events &middot; Line of duty support &middot; Private mental health support &middot; Behavior management</div>
        </div>
        <div class="alloc" data-aos="fade-right" data-aos-delay="300">
          <div class="alloc-top"><span class="alloc-name">50% &rarr; Technology Infrastructure &amp; Platform</span><span class="alloc-pct" style="color:#5a9a50;">50%</span></div>
          <div class="alloc-track"><div class="alloc-fill f50" id="bar3"></div></div>
          <div class="alloc-note">Platform development &middot; Secure hosting &middot; Staff &amp; operations &middot; National scaling &middot; LMS infrastructure &middot; Compliance systems</div>
        </div>
      </div>
    </div>
  </section>

</div>

<footer class="site-footer">
  <div class="footer-inner">
    <div>
      <div class="footer-logo">
        <img src="assets/img/logo.png" alt="Police Officers Connect">
      </div>
      <div class="footer-brand">Police Officers Connect</div>
      <div class="footer-sub-txt">UMYO Network</div>
      <a class="footer-url" rputerLink="/">🌐 www.umyopd.site</a>
    </div>
    <div>
      <div class="footer-col-title">Navigation</div>
      <ul class="footer-links ps-0">
        <li><a routerLink="/">Home</a></li>
        <li><a routerLink="/about">About the Platform</a></li>
        <li><a routerLink="/support">Officer &amp; Family Support</a></li>
        <li><a routerLink="/business">For Businesses</a></li>
        <li><a routerLink="/services">Servcies</a></li>
        <li><a routerLink="/cf">Card Features</a></li>
        <li><a routerLink="/terms">Terms & Condition</a></li>
      </ul>
    </div>
    <div>
      <div class="footer-col-title">Contact</div>
      <div class="footer-contact">
        <div><strong style="color:var(--white);">UMYO Police Connect</strong></div>
        <div>UMYO Network</div>
        <div>3225 Martin Luther King Blvd</div>
        <div>Dallas, Texas 75210</div>
        <div><a routerLink="/">www.umyopd.site</a></div>
      </div>
    </div>
  </div>
</footer>
<div class="footer-bottom">&#169; 2025 UMYO Police Connect &middot; Built for Officers &middot; Powered by Community &middot; Network. Support. Grow. Recognize.</div>